import React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PropTypes from 'prop-types';

const OverflowMenu = ({ menuItems, Icon = null }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderIcon = (icon) => {
    if (!icon) return null;

    // If icon is a string 
    if (typeof icon === 'string') {
      if(Icon) {
        return <img src={icon} alt="" style={{ padding : 5, width: 24, height: 24, background: '#fff' }} />;
      }
      return <img src={icon} alt="" style={{ marginRight: 8, width: 14, height: 14 }} />;
    }

    // If icon is a React element
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        style: { marginRight: 7, fontSize: 16 },
      });
    }

    // If icon is a component type (function/class)
    if (typeof icon === 'function' || (typeof icon === 'object' && icon.$$typeof)) {
      const IconComponent = icon;
      return <IconComponent style={{ marginRight: 7, fontSize: 16 }} />;
    }

    return null;
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="overflow-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{padding : Icon ? '0px' : '8px 0'}}
      >
        {renderIcon(Icon) || <MoreVertIcon />}
      </IconButton>
      <Menu
        id="overflow-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index * 2}
            onClick={() => {
              item.onClick();
              handleClose();
            }}
            disabled={item.disabled}
            sx={{
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              ...item.sx,
            }}
          >
            {renderIcon(item.icon)}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

OverflowMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.any,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      sx: PropTypes.object,
      Icon: PropTypes.elementType,
    })
  ).isRequired,
  Icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]),
};

export default OverflowMenu;